import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PropsTable = makeShortcode("PropsTable");
const PropsTableRow = makeShortcode("PropsTableRow");
const Link = makeShortcode("Link");
const PropsTableSxRow = makeShortcode("PropsTableSxRow");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Example`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <StyledOcticon icon={CheckIcon} size={32} color="success.fg" sx={{mr: 2}} />
  <StyledOcticon icon={XIcon} size={32} color="danger.fg" />
</>
`}</code></pre>
    <h2>{`Props`}</h2>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="ariaLabel" type="string" description="Specifies the aria-label attribute, which is read verbatim by screen readers " mdxType="PropsTableRow" />
  <PropsTableRow name="icon" type="Component" description={<>
        Checks the input by default in uncontrolled modeName of the <Link href="https://primer.style/octicons/" mdxType="Link">Octicon component</Link> used in the 
      </>} mdxType="PropsTableRow" />
  <PropsTableRow name="color" type="string" description={<>
        Sets an override color for the Octicon. Compatible with colors from the <Link href="https://primer.style/primitives/colors" mdxType="Link">Primer color system</Link>." 
      </>} mdxType="PropsTableRow" />
  <PropsTableRow name="size" defaultValue="16" type="number" description="Sets the uniform `width` and `height` of the SVG element" mdxType="PropsTableRow" />
  <PropsTableRow name="verticalAlign" defaultValue="text-bottom" type="string" description="Sets the `vertical-align` CSS property" mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: false,
      fullTestCoverage: false,
      usedInProduction: true,
      usageExamplesDocumented: true,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      